import { AiLoader } from '@/components/ats';

export const AIFillScorecardLoader = () => {
  return (
    <AiLoader
      config={{
        steps: [
          { id: '1', label: 'Reviewing interview information...', duration: 1 },
          { id: '2', label: 'Reading the interview transcript...' },
          { id: '3', label: 'Completing the scorecard...' },
        ],
        message: {
          title: 'AI is filling out the scorecard',
          description:
            'AI is reviewing the interview transcript and completing the scorecard for you',
        },
      }}
    />
  );
};
